import axios from 'axios'

export default {
  async list (occurrenceId, filter) {
    const path = `${
      process.env.VUE_APP_API_URL
    }/api/v2/occurrences/${occurrenceId}/card-transaction-occurrences`
    const response = await axios.get(path, {
      params: {
        index: filter.index,
        length: filter.length,
        suspiciousType: filter.suspiciousType
      }
    })
    return response && response.status === 200 ? response.data : null
  },
  async reportFraud (cardTransactonOcurrences, note) {
    const path = `${
      process.env.VUE_APP_API_URL
    }/api/v2/occurrences/report-fraud`
    const data = {
      ids: cardTransactonOcurrences.map(c => c.id),
      note
    }

    try {
      const response = await axios.post(path, data)

      return response && response.status === 204
    } catch (ex) {
      return false
    }
  }
}
